import { useEffect, useState, useMemo } from 'react';
const useDrSchedules = (
  schedules: any[],
  addressId: number | any,
  providers: { id: number }[]
) => {
  const [matchedProviders, setMatchedProviders] = useState<{ id: number }[]>([]);

  const parseSchDoctorIds = useMemo(() => {
    return (schDoctorIds: any): number[] => {
      try {
        if (Array.isArray(schDoctorIds)) {
          return schDoctorIds.map(id => parseInt(id, 10)).filter(id => !isNaN(id));
        } else {
          console.error('Unexpected type for sch_doctor_ids:', typeof schDoctorIds);
          return [];
        }
      } catch (error) {
        console.error('Error parsing sch_doctor_ids:', error);
        return [];
      }
    };
  }, []);

  useEffect(() => {
    if (!schedules || schedules.length === 0 || addressId === null || !providers || providers.length === 0) {
      setMatchedProviders([]);
      return;
    }

    const filteredSchedules = schedules.filter(schedule => schedule.address_id === addressId);

    const allDoctorIds = filteredSchedules.reduce<number[]>((acc, schedule) => {
      const parsedSchDoctorIds = parseSchDoctorIds(schedule.sch_doctor_ids);
      return [...acc, ...parsedSchDoctorIds];
    }, []);
    
    const uniqueDoctorIds = Array.from(new Set(allDoctorIds));
    const matched = providers.filter(provider => uniqueDoctorIds.includes(provider.id));
    setMatchedProviders(matched);
  }, [schedules, addressId, providers, parseSchDoctorIds]);

  return matchedProviders;
};

export default useDrSchedules;
